export class ModifierDto {
  public id: number;
  public name: string;
  public portionSize: number;

  constructor(id?: number, name?: string, portionSize?: number) {
    this.id = id;
    this.name = name;
    this.portionSize = portionSize;
  }
}
